const colors = {
  orange: "rgba(241, 143, 22, 0.8)",
  azure: "#26ABDF",
  white: "#ffffff",
  darkBlue: "#1F1F75",
  grey: "#828282",
  yellow: "#FFB600",
};

export default colors;
